import {RouteObject} from 'react-router-dom';
import {ROUTES} from '../routes';
import {JobCreate} from './job-create-update';
import {JobListing} from './job-listing';
import {JobTabs} from './job-tabs';
import {JobSummaryDto} from '../api/generated/index.defs';

const WithoutColumns = ['partnerSiteName'] satisfies (keyof JobSummaryDto)[];

export const JobRoutes: RouteObject = {
  path: ROUTES.ADMIN.JOBS.path,
  children: [
    {
      path: ROUTES.ADMIN.JOBS.INDEX.path,
      element: <JobListing withoutColumns={WithoutColumns} />,
    },
    {
      path: ROUTES.ADMIN.JOBS.CREATE.path,
      element: <JobCreate />,
    },
    {
      path: ROUTES.ADMIN.JOBS.DETAIL.path,
      element: <JobTabs />,
    },
  ],
};
